import Nullstack from 'nullstack';
export default function IconBrandTripadvisor({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-tripadvisor",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "6.5",
    cy: "13.5",
    r: "1.5"
  }), "   ", Nullstack.element("circle", {
    cx: "17.5",
    cy: "13.5",
    r: "1.5"
  }), "   ", Nullstack.element("path", {
    d: "M17.5 9a4.5 4.5 0 1 0 3.5 1.671l1 -1.671h-4.5z"
  }), "   ", Nullstack.element("path", {
    d: "M6.5 9a4.5 4.5 0 1 1 -3.5 1.671l-1 -1.671h4.5z"
  }), "   ", Nullstack.element("path", {
    d: "M10.5 15.5l1.5 2l1.5 -2"
  }), "   ", Nullstack.element("path", {
    d: "M9 6.75c2 -.667 4 -.667 6 0"
  }), " ");
}